<template>
<div id="catalogos_transportes">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-row align-center justify-center>
            <v-col xs="12">
                <base-material-card color="primary" icon="mdi-truck-fast-outline" title="Administrar Transportes" class="elevation-1 px-5 py-3">
                    <v-card-actions>
                        <v-spacer />

                        <v-btn fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <div id="datagrid">
                            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <v-btn x-small fab dark color="success" @click.native="editar(props.row.uuid)" title="Editar Registro" v-tippy>
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab dark color="pink" @click.native="eliminar(props.row.uuid)" title="Eliminar Registro" v-tippy>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
    <v-dialog v-model="modal" max-width="60%">
        <v-card>
            <v-card-title>
                <span class="headline">{{ tituloModal }}</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-card>
                            <v-card-text>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.nombre" label="Nombre" :rules="[this.$rules.required]" maxlength="150"></v-text-field>
                                    </v-col>
                                    <v-col sm="8" md="8" lg="8">

                                        <v-autocomplete v-model="model.uuid_figura_transporte" label="Figura Transporte" :rules="[this.$rules.required]" :items="figuras" :hide-no-data="true" item-text="nombre" item-value="uuid">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.rfc}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.rfc}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-autocomplete v-model="model.config_vehicular" label="Configuración Vehícular" :rules="[this.$rules.required]" :items="configauto" :hide-no-data="true" :item-text="getNombreClave" item-value="clave"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="model.placa_vm" label="Placa VM" :rules="[this.$rules.required]" maxlength="50"></v-text-field>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="model.anio_modelo_vm" label="Año Modelo VM" :rules="[this.$rules.required]" maxlength="4"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">

                                        <v-autocomplete v-model="model.permiso_sct" label="Permiso SCT" :rules="[this.$rules.required]" :items="permisos_sct" :hide-no-data="true" item-text="descripcion" item-value="clave"></v-autocomplete>

                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="model.no_permiso_sct" label="No. Permiso SCT" maxlength="100"></v-text-field>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="model.peso_bruto_vehicular" label="Peso Bruto Vehicular" maxlength="100" type="number" :rules="[this.$rules.required]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.asegura_carga" label="Asegura Carga" maxlength="255"></v-text-field>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.poliza_carga" label="Poliza Carga" maxlength="100"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.asegura_resp_civil" label="Asegura Resp Civil" maxlength="255"></v-text-field>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.poliza_resp_civil" label="Poliza Resp Civil" maxlength="100"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.asegura_med_ambiente" label="Asegura Medio Ambiente" maxlength="255"></v-text-field>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.poliza_med_ambiente" label="Poliza Medio Ambiente" maxlength="100"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete clearable @change="model.uuid_remolque2=null" v-model="model.uuid_remolque1" label="Remolque1" :items="remolques" :hide-no-data="true" item-text="identificador" item-value="uuid">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.identificador}} - {{ item.placas}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.identificador}} - {{ item.placas}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete clearable v-if="model.uuid_remolque1!=undefined && model.uuid_remolque1!=null" v-model="model.uuid_remolque2" label="Remolque2" :items="remolques" :hide-no-data="true" item-text="identificador" item-value="uuid">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.identificador}} - {{ item.placas}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.identificador}} - {{ item.placas}}
                                            </template></v-autocomplete>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-switch v-model="model.activo" :label="model.activo" true-value="Activo" false-value="Inactivo"></v-switch>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>

                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="default" small @click="modal=false">
                    <v-icon small>mdi-cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" small @click="guardar">
                    <v-icon small>mdi-check-circle-outline</v-icon> Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    name: "DashboardDataTables",
    created: function () {
        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
        this.model = this.clean_model();        
        this.cargarFigurasTransportes();
        this.cargarConfigTransporte();
        this.cargarRemolques();
        this.cargarpermisos();
        this.cargar();
    },
    computed: {
        tituloModal() {
            return this.updateModel === false ? "Nuevo Transporte" : "Editar Transporte";
        },
    },
    data: () => ({
        URL:"",
        URL_SAT:"",
        figuras: [],
        configauto: [],
        remolques: [],
        permisos_sct: [],
        tabla: "transportes",
        modal: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Transportes",
                disabled: true,
                href: "",
            },
        ],
        model: {},
        updateModel: false,
        columns: ["nombre", "config_vehicular", "placa_vm", "anio_modelo_vm", "permiso_sct", "activo", "actions"],
        options: {
            filterable: true,
            headings: {
                nombre: "Nombre",
                "config_vehicular": "Config. Vehícular",
                "placa_vm": "Placa VM",
                "anio_modelo_vm": "Año modelo VM",
                "permiso_sct": "Permiso SCT",
                actions: "Operaciones"
            }
        },
        items: [],
        search: undefined,
    }),
    methods: {
        getNombreClave: function (row) {
            return row.clave + " - " + row.descripcion;
        },
        cargarConfigTransporte: function () {
            var self = this;
            this.$axios.post(this.URL_SAT + "list_config_autotransporte/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.configauto = res.data.sort(function (a, b) {
                            if (a.clave > b.clave) {
                                return 1;
                            }
                            if (a.clave < b.clave) {
                                return -1;
                            }
                            return 0;
                        });                
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener la configuración transporte.",
                        footer: "",
                    });
                    console.log(err);
                });               
        },
        cargarpermisos: function () {
            var params = {
                TableName: "sat_tipo_permiso",
            };

            var self = this;
            this.$axios.post(this.URL_SAT + "list_tipo_permiso/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.permisos_sct = res.data.sort(function (a, b) {
                                if (a.clave > b.clave) {
                                    return 1;
                                }
                                if (a.clave < b.clave) {
                                    return -1;
                                }
                                return 0;
                            });              
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los permisos.",
                        footer: "",
                    });
                    console.log(err);
                });   

        },

        cargarFigurasTransportes: function () {
            var params = {
                uuid_empresa: this.model.uuid_empresa
            };
            var self = this;
            this.$axios.post(this.URL + "list_figuras_transporte/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.figuras = res.data;
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener las figuras transporte.",
                        footer: "",
                    });
                    console.log(err);
                });
        },
        cargarRemolques: function () {
            var params = {
                uuid_empresa: this.model.uuid_empresa
            };
            var self = this;
            this.$axios.post(this.URL + "list_remolque/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.remolques = res.data;
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los remolques.",
                        footer: "",
                    });
                    console.log(err);
                });
        },
        cargar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            
            var params = {
                uuid_empresa: this.model.uuid_empresa
            };
            var self = this;
            this.$axios.post(this.URL + "list_transporte/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.items = res.data;
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });            
        },
        agregar: function () {
            this.model = this.clean_model();
            this.updateModel = false;
            this.modal = true;

        },
        editar: function (id) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;
            this.model = this.clean_model();
            var params = {
                uuid: id,
                uuid_empresa: this.model.uuid_empresa        
            };

            this.$axios.post(this.URL + "list_transporte/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.model = res.data[0];
                        self.modal = true;
                        self.updateModel = true;                  
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.$root.$dialogLoader.hide();
                });                        

        },
        eliminar: function (id) {
        var self = this;
        self.$swal({
            type: "info",
            title: "Cuidado",
            text: "¿Está seguro de eliminar el registro?",
            footer: "",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                var data = {
                    uuid: id,                        
                };
                this.$axios.post(this.URL + "delete_transporte/", data)
                    .then(res => {
                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se eliminó correctamente.",
                            footer: "",
                        });
                        self.cargar();
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al eliminar el registro.",
                            footer: "",
                        });
                        console.log(err);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });                
            }
        });

    },
        guardar: function () {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                var url = this.URL + "create_transporte/";
                if (this.updateModel === false) 
                    this.model.uuid = this.$uuid.v4();
                else
                    url = this.URL + "update_transporte/";
                    
                var self = this;
                this.$axios.post(url, this.model)
                .then(res => {                    
                    self.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se guardó correctamente.",
                        footer: "",
                    });
                    self.modal = false;                                          
                })
                .catch(err => {
                    console.log(err);
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });                        
                }).then(() => {                        
                    self.add_registro = false;
                    self.cargar();
                    this.$root.$dialogLoader.hide();
                });            
            }
        },
        clean_model: function () {
            return {
                uuid: "",
                uuid_empresa: this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa"))),
                nombre: "",
                config_vehicular: "",
                uuid_figura_transporte: "",
                placa_vm: "",
                anio_modelo_vm: "",
                permiso_sct: "",
                no_permiso_sct: "",
                asegura_carga: "",
                poliza_carga: "",
                asegura_resp_civil: "",
                poliza_resp_civil: "",
                asegura_med_ambiente: "",
                poliza_med_ambiente: "",
                uuid_remolque1: "",
                uuid_remolque2: "",
                peso_bruto_vehicular:"",
                activo: "Activo",

            };
        },
        validaRemolque: function () {
            try {
                if (this.model.uuid_remolque1 != null)
                    if (this.model.uuid_remolque1 == this.model.uuid_remolque2)
                        return "Remolque se encuentra duplicado";
                    else
                        return true;
            } catch (error) {
                return true;
            }
        },
    },
};
</script>
